import React from 'react';
import { bool, string, func } from 'prop-types';

import CSS from './styles.scss';

import Menu from './Menu';
import EBook from 'components/EBook';
import Notebook from 'components/Notebook';

const ReaderViews = ({
    activeMenu,
    createPageViewerFail,
    isLoading,
    toggle,
    showPageSelector
  }) => {
  return (
    <div className={ CSS['container'] }>
      <Menu
        isLoading={ isLoading }
        isDisabled={ createPageViewerFail }
        activeMenu={ activeMenu }
        showPageSelector={ showPageSelector }
        parentToggle={ toggle }
      />

      <EBook isShown={ activeMenu === 'E-book' } />
      <Notebook isShown={ activeMenu !== 'E-book' } toggle={ toggle } />
    </div>
  );
};

ReaderViews.propTypes = {
  activeMenu: string,
  createPageViewerFail: bool,
  isLoading: bool,
  toggle: func,
  showPageSelector: bool
};


export default ReaderViews;
